import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

type Props = {
  open: boolean
  celex: string
  hasExpertSpan: boolean
  blockedMessage?: string | null
  onOpenChange: (open: boolean) => void
  onSelectTier: (tier: 1 | 2 | 3) => void
  isSubmitting?: boolean
}

export default function AssignTierBeforeApprovalDialog({
  open,
  celex,
  hasExpertSpan,
  blockedMessage = null,
  onOpenChange,
  onSelectTier,
  isSubmitting = false,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='sm:max-w-lg'>
        <DialogHeader>
          <DialogTitle>Assign a tier before approving</DialogTitle>
          <DialogDescription>
            {celex} has no scope tier yet. Choose a tier to assign and approve this
            document. Tiers 1 and 2 also need an expert scope selection in the
            document body.
          </DialogDescription>
        </DialogHeader>
        <div className='grid gap-3'>
          {blockedMessage ? (
            <p className='text-sm text-destructive'>{blockedMessage}</p>
          ) : null}
          <div className='grid grid-cols-1 gap-2 sm:grid-cols-3'>
            <Button
              type='button'
              variant='default'
              className='w-full'
              disabled={isSubmitting || !hasExpertSpan}
              onClick={() => onSelectTier(1)}
            >
              Tier 1 and approve
            </Button>
            <Button
              type='button'
              variant='default'
              className='w-full'
              disabled={isSubmitting || !hasExpertSpan}
              onClick={() => onSelectTier(2)}
            >
              Tier 2 and approve
            </Button>
            <Button
              type='button'
              variant='default'
              className='w-full'
              disabled={isSubmitting}
              onClick={() => onSelectTier(3)}
            >
              Tier 3 and approve
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
